import axios from "axios";
//const API_URL_Local = "http://172.27.181.225:8100/api/v2/";
//const API_URL_Local = "https://amethyst.gistda.or.th/api/v2/"
const API_URL_Local = process.env.REACT_APP_API_URL;
// const API_URL_Local = "http://172.27.184.102:8123/api/v2/";
const API_URL_Local1 = "https://172.27.181.168/api/v2/";
const handleError = (error) => {
  if (error.response) {
    // Error จากการตอบกลับของเซิร์ฟเวอร์
    if(error.response.data.error_description){
      throw error.response.data.error_description
    }else{
      throw "respone error"
    }
    
  } else if (error.request) {
    // Error เกิดขึ้นในระหว่าง request ถูกส่งแต่ไม่ได้รับการตอบกลับ
    console.error("Network Error:", error.request);
    //alert("Network error. Please check your internet connection.");
    throw "Request Error"
  } else {
    // Error จากการตั้งค่าหรืออื่น ๆ
    console.error("Error:", error.message);
    
    //alert(error.message);
    throw "Error Message"
  }
};
const GetOneDataDrone = (drone_id) => {
  console.log(drone_id);
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    return axios
      .post(
        API_URL_Local + "regulator/drone-data-reg",
        {
          drone_id,
        },
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      )
      .then((response) => {
        //console.log(response);
        return response;
      })
      .catch((error) => {
        handleError(error);
        throw error;
      });
  }
};

const dronelist = () => {
  const token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    return axios
      .get(
        API_URL_Local + "regulator/drone-list",

        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        handleError(error);
        throw error;
      });
  }
};
const UpdateDroneRegisStatus = (drone_id, status, comment) => {
  console.log(drone_id, status);
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    return axios
      .post(
        API_URL_Local + "regulator/update-drone-regis-status",
        {
          drone_id,
          status,
          comment,
        },
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      )
      .then((response) => {
        //console.log(response);
        return response;
      })
      .catch((error) => {
        handleError(error);
        throw error;
      });
  }
};
const Opearationdata = (operationid) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    if (operationid) {
      return axios
        .get(
          API_URL_Local + "regulator/operation-data",
          {
            params: { operation_id: operationid },
          },
          {
            headers: {
              Authorization: `Bearer ${access_token}`,
            },
          }
        )
        .then((response) => {
          //console.log(response);
          return response;
        })
        .catch((error) => {
          handleError(error);
          throw error;
        });
    } else {
      return axios
        .get(API_URL_Local + "regulator/operation-data", {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        })
        .then((response) => {
          //console.log(response);
          return response;
        })
        .catch((error) => {
          handleError(error);
          throw error;
        });
    }
  }
};
const AuthorizedOperation = (operation_id) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    return axios
      .post(
        API_URL_Local + "regulator/authorized-operation",
        {
          operation_id,
        },
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      )
      .then((response) => {
        //console.log(response);
        return response;
      })
      .catch((error) => {
        handleError(error);
        throw error;
      });
  }
};
const DeniedOperation = (operation_id) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    return axios
      .post(
        API_URL_Local + "regulator/denied-operation",
        {
          operation_id,
        },
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      )
      .then((response) => {
        //console.log(response);
        return response;
      })
      .catch((error) => {
        handleError(error);
        throw error;
      });
  }
};
const RescindedOperation = (operation_id) => {
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    return axios
      .post(
        API_URL_Local + "regulator/rescinded-operation",
        {
          operation_id,
        },
        {
          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      )
      .then((response) => {
        //console.log(response);
        return response;
      })
      .catch((error) => {
        handleError(error);
        throw error;
      });
  }
};
const Getfile = async (drone_id, filename) => {
  console.log(drone_id, filename);
  const access_token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    try {
      const response = await axios.post(
        API_URL_Local + "regulator/registration/file",
        {
          drone_id,
          filename,
        },
        {
          responseType: "blob",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${access_token}`,
          },
        }
      );
      console.log(response);
      return response;
    } catch (error) {
      console.log("Error in 'WHJG5' \n", error.response.data);
      handleError(error);
      throw error.response.data.error_description;
    }
  }
};
const OperationDoc = (operation_id, filename) => {
  const token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    return axios
      .get(API_URL_Local + "regulator/operationdoc/file", {
        params: {
          operation_id: operation_id,
          filename: filename,
        },
        responseType: "blob",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        handleError(error);
        throw error;
      });
  }
};

const GetPilotLicenseData = async () => {
  try {
    const access_token = sessionStorage.getItem("access_token");
    const checktoken = localStorage.getItem("access_token");
    if (checktoken != null) {
      const response = await axios.get(API_URL_Local + "regulator/pilot-license-data", {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      })

      return response;
    }
  } catch (err) {
    throw err ;
  }
}

const UpdatePilotRegistStatus = async(id,status,comment)=>{
    try {
      const access_token = sessionStorage.getItem("access_token");
      const checktoken = localStorage.getItem("access_token");
      if (checktoken != null) {
      const response = await axios.post(
        API_URL_Local + "regulator/update-pilot-regis-status",
        {
          id,
          status,
          comment
        },
        {

          headers: {
            Authorization: `Bearer ${access_token}`,
          },
        }
      );
      console.log(response);
      return response;
    } 
  }catch (error) {
    console.log("Error in 'WS4SD5' \n", error.response.data);
    return error.response.data.error_description;
  }
}

const GetPilot_Status = async (status_id) => {
  try {
    const access_token = sessionStorage.getItem("access_token");
    const checktoken = localStorage.getItem("access_token");

    if (checktoken != null && access_token != null) { 
      let config1 =  {
        params: {
          status_id :status_id
        },
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      }  
      let config2 =  {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      }
      const response = await axios.get(API_URL_Local + "regulator/pilot-status", status_id?config1:config2);
        return response;
    } else {
      throw new Error("Access token is not available.");
    }
  } catch (err) {
   throw err
  }
};
const Certificate_File = (id, filename) => {
  const token = sessionStorage.getItem("access_token");
  const checktoken = localStorage.getItem("access_token");
  if (checktoken != null) {
    return axios
      .get(API_URL_Local + "regulator/certificate/file", {
        params: {
          id: id,
          filename: filename,
        },
        responseType: "blob",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        console.log(response)
        return response; 
      }).catch((error)=>{
        handleError(error)
      })
  }
};
const RegulatorService = {
  dronelist,
  GetOneDataDrone,
  UpdateDroneRegisStatus,
  Opearationdata,
  AuthorizedOperation,
  DeniedOperation,
  RescindedOperation,
  Getfile,
  OperationDoc,
  GetPilotLicenseData,
  GetPilot_Status,
  UpdatePilotRegistStatus,
  Certificate_File
};

export default RegulatorService;
